// import parseTime, formatTime and set to filter

/**
 * 房间预订类型  // 1-整间 2-床位
 * @param {String} string
 */
export function measureType(ordSts) {
  const newOrdSts = {
    '0': '整间',
    '1': '床位'
  }
  return newOrdSts[ordSts] ? newOrdSts[ordSts] : ordSts
}
/**
 * 支付状态  // 0-未支付 1-已支付
 * @param {String} string
 */
export function payStatus(ordSts) {
  const newOrdSts = {
    '0': '未支付',
    '1': '已支付'
  }
  return newOrdSts[ordSts] ? newOrdSts[ordSts] : '未支付'
}


